/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_AppServices_Broker_BrokerDto } from '../models/Wealthlane_CustomerService_AppServices_Broker_BrokerDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BrokerService {

    /**
     * @returns Wealthlane_CustomerService_AppServices_Broker_BrokerDto OK
     * @throws ApiError
     */
    public static getApiCustomerBrokerOptions(): CancelablePromise<Array<Wealthlane_CustomerService_AppServices_Broker_BrokerDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/broker/options',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
